import Settings from './Settings.vue'
import List from './List.vue'
import New from './New.vue'
import { Route } from 'vue-router/types/router'
// import Edit from "./Edit.vue"
// import Delete from "./Delete.vue"

export const All = [
  Settings,
  List,
  New
  // Edit,
  // Delete
]

export default {
  Settings,
  List,
  New
  // Edit,
  // Delete
}

export const RouteConfig = [
  {
    path: 'logins',
    component: Settings,
    name: 'settings-logins',
    children: [
      {
        path: 'list',
        component: List,
        name: 'settings-logins-list'
      },
      {
        path: 'new',
        component: New,
        name: 'settings-clients-new'
      },
      {
        path: ':loginId',
        component: New,
        props: function(route: Route) {
          return { loginId: route?.params?.loginId }
        }
      },
      // {
      //   path: ":clientId/delete",
      //   component: Delete,
      //   name: "settings-clients-delete",
      //   props: function(route) {
      //     return { clientId: route?.params?.clientId }
      //   }
      // },
      {
        path: '',
        component: Settings
      }
    ]
  }
]
